import { gql } from '@apollo/client';

export const AuthTokensFragment = gql`
    fragment AuthTokens on AuthTokens {
        accessToken
        refreshToken
    }
`;
